import * as React from 'react';import { SelectionReportContainer, FrequencyReportContainer } from 'app/area/reports';
import { reportTypes } from './constants';
import { FavouriteResultProps } from './types';
import { CaseReportExternalProps } from 'app/area/case-report/case-report';
import { StatisticalReportExternalProps } from 'app/area/reports/types';
import { CaseReport } from 'app/area/case-report';

const renderers = {
  [reportTypes.selectionReport]: SelectionReportContainer,
  [reportTypes.frequencyReport]: FrequencyReportContainer,
  [reportTypes.mergedReport]: (() => <div>Not implemented</div>)
};

export const FavouriteResult = (
  props:
    FavouriteResultProps &
    { report: number } &
    {
      caseReportExternalProps?: CaseReportExternalProps; 
      statisticalReportExternalProps?: StatisticalReportExternalProps;
    }
) => {

  const { report } = props;
  const Component = renderers[report];

  if (!!Component) {
    return <Component {...props} {...(props?.statisticalReportExternalProps ?? {})} />;
  }

  return <CaseReport {...props} {...(props?.caseReportExternalProps ?? {})} />;
};
